import { Collapse } from '@blueprintjs/core'
import { Box, Flex } from '@rebass/grid'
import * as firebase from 'firebase'
import * as R from 'ramda'
import * as React from 'react'
import { connect } from 'react-redux'
import { RootState } from 'src/store'
import styled from 'styled-components'
import Insight from '../Insight'
import Panel from './Panel'

const InsightBlock = styled.div`
  width: 100%;
  min-height: 200px;
  padding: 20px;
  padding-bottom: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  img {
    max-width: 100px;
    max-height: 100px;
    width: 100%;
    height: auto;
    margin-bottom: 12px;
  }

  h4 {
    font-size: 14px;
    line-height: normal;
    letter-spacing: 0.7px;
    color: #cdcdcd;
    font-weight: normal;
  }
`

interface IConnectProps {
  lectureId: string
  chapterIdx: number
  isActive: boolean
  onToggle?: () => void
}
type IProps = ReturnType<typeof mapState> & IConnectProps
const Chapter: React.SFC<IProps> = ({
  isSpeaker,
  isParticipant,
  lectureId,
  chapterIdx,
  currentLecture,
  chapter,
  isActive,
  onToggle
}) => {
  return (
    <Flex flexDirection="column">
      <Box mb={20}>
        <Panel
          isParticipant={isParticipant}
          idx={chapterIdx}
          trial={chapter.trial}
          isOpen={isActive}
          onToggle={onToggle}
        >
          {chapter.title}
        </Panel>
      </Box>
      <Collapse
        isOpen={isActive}
        keepChildrenMounted={true}
        transitionDuration={500}
      >
        <Box px={24}>
          {!chapter.trial && !isSpeaker && !isParticipant ? (
            <InsightBlock>
              <img src={require('./../../images/common/icon/icon-lock.png')} />
              <h4>此為付費觀點，請參與講座</h4>
            </InsightBlock>
          ) : (!chapter.trial &&
              currentLecture &&
              new Date() < currentLecture.startedAt.toDate()) ||
            chapter.insightIds.length === 0 ? (
            <InsightBlock>
              <img
                src={require('./../../images/common/icon/icon-waiting.png')}
              />
              <h4>觀點準備中，敬請期待</h4>
            </InsightBlock>
          ) : (
            chapter.insightIds.map(insightId => {
              return (
                <Insight
                  key={insightId}
                  lectureId={lectureId}
                  chapterIdx={chapterIdx}
                  insightId={insightId}
                />
              )
            })
          )}
        </Box>
      </Collapse>
    </Flex>
  )
}

const mapState = (
  { lectures, participants }: RootState,
  { lectureId, chapterIdx }: IConnectProps
) => {
  const currentUser = firebase.auth().currentUser
  const currentLecture = lectureId ? lectures[lectureId] : null
  const isSpeaker =
    currentLecture !== null &&
    currentUser !== null &&
    R.contains(currentUser.uid, currentLecture.speakerIds)
  const isParticipant =
    currentUser !== null &&
    participants[lectureId] !== null &&
    participants[lectureId] !== undefined &&
    R.contains(currentUser.uid, participants[lectureId])
  return {
    isSpeaker,
    isParticipant,
    currentLecture,
    chapter: lectures[lectureId].units[0].chapters[chapterIdx]
  }
}

export default connect(mapState)(Chapter)



// WEBPACK FOOTER //
// ./src/components/Chapter/index.tsx